var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "setting_main_contents",
      attrs: { id: "dispatch-job-main-content" },
      on: { scroll: _vm.scrollMenuItem }
    },
    [
      _c("div", { class: { overlay_setting: _vm.isLoadingData } }, [
        _c("i", { class: { loadding_setting: _vm.isLoadingData } })
      ]),
      _c("div", { staticClass: "setting_heading" }, [
        _c("h1", { staticClass: "setting_heading_title" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.dispatchJobSettingProperty.TAB_HEADER) +
              "\n    "
          )
        ]),
        _c("p", { staticClass: "setting_heading_explain" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.dispatchJobSettingProperty.SUB_HEADER) +
              "\n    "
          )
        ])
      ]),
      _c("div", { staticClass: "setting_tab" }, [
        _c("div", { staticClass: "setting_tab_nav" }, [
          _c("ul", { staticClass: "setting_tab_nav_list" }, [
            _c(
              "li",
              {
                staticClass: "setting_tab_nav_item is_active",
                attrs: { id: "t2" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.changeNavTab(_vm.DISPLAY_SETTINGS_TAB)
                  }
                }
              },
              [
                _c("span", { staticClass: "setting_tab_nav_text" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.dispatchJobSettingProperty
                          .DISPLAY_SETTINGS_TAB_TITLE
                      ) +
                      "\n          "
                  )
                ])
              ]
            ),
            _c(
              "li",
              {
                staticClass: "setting_tab_nav_item",
                attrs: { id: "t3" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.changeNavTab(_vm.HEADLINE_TEXT_TAB)
                  }
                }
              },
              [
                _c("span", { staticClass: "setting_tab_nav_text" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.dispatchJobSettingProperty.HEADLINE_TEXT_TAB_TITLE
                      ) +
                      "\n          "
                  )
                ])
              ]
            ),
            _c(
              "li",
              {
                staticClass: "setting_tab_nav_item",
                attrs: { id: "t4" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.changeNavTab(_vm.DETAIL_INFORMATION_TAB)
                  }
                }
              },
              [
                _c("span", { staticClass: "setting_tab_nav_text" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.dispatchJobSettingProperty
                          .DETAIL_INFORMATION_TAB_TITLE
                      ) +
                      "\n          "
                  )
                ])
              ]
            ),
            _c(
              "li",
              {
                staticClass: "setting_tab_nav_item",
                attrs: { id: "t5" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.changeNavTab(_vm.LIST_INFORMATION_TAB)
                  }
                }
              },
              [
                _c("span", { staticClass: "setting_tab_nav_text" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.dispatchJobSettingProperty
                          .COMPANY_INFORMATION_TAB_TITLE
                      ) +
                      "\n          "
                  )
                ])
              ]
            )
          ])
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.navTab === _vm.DISPLAY_SETTINGS_TAB,
                expression: "navTab === DISPLAY_SETTINGS_TAB"
              }
            ],
            staticClass: "setting_tab_content"
          },
          [
            _c(
              "div",
              { staticClass: "setting_tab_content_panel is_active" },
              [
                _c("DisplaySettingsTab", {
                  attrs: {
                    displaySetting: _vm.dispatchJobSearchForm.displaySetting,
                    groupName: _vm.groupName,
                    jobCategories: _vm.jobCategories,
                    property: _vm.property,
                    resourceFields: _vm.resourceFields,
                    useType: _vm.itemIsUsedInDisplaySetting,
                    userId: _vm.log.info.userId
                  },
                  on: {
                    updatedDisplaySetting: _vm.updatedDisplaySetting,
                    updatedProperty: _vm.updatedProperty,
                    updateResourceField: _vm.updateResourceField,
                    getJobResourceFields: function($event) {
                      return _vm.getDispatchJobResourceFields(
                        _vm.property,
                        $event
                      )
                    },
                    refreshResourceList: function($event) {
                      return _vm.refreshResourceList($event)
                    },
                    createLogger: function($event) {
                      return _vm.createLogger($event)
                    },
                    sendLogger: _vm.sendLogger
                  }
                })
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.navTab === _vm.HEADLINE_TEXT_TAB,
                expression: "navTab === HEADLINE_TEXT_TAB"
              }
            ],
            staticClass: "setting_tab_content"
          },
          [
            _c(
              "div",
              { staticClass: "setting_tab_content_panel is_active" },
              [
                _c("HeadlineTextTab", {
                  ref: "HeadlineTextTabComponent",
                  attrs: {
                    bodySettings: _vm.bodySettings,
                    headingSettings: _vm.headingSettings,
                    groupName: _vm.groupName,
                    jobCategories: _vm.jobCategories,
                    property: _vm.property,
                    resourceFields: _vm.resourceFields,
                    useType: _vm.itemIsUsedInHeadingBodySetting,
                    userId: _vm.log.info.userId
                  },
                  on: {
                    updatedProperty: _vm.updatedProperty,
                    updateResourceField: _vm.updateResourceField,
                    getJobResourceFields: function($event) {
                      return _vm.getDispatchJobResourceFields(
                        _vm.property,
                        $event
                      )
                    },
                    refreshResourceList: function($event) {
                      return _vm.refreshResourceList($event)
                    },
                    createLogger: function($event) {
                      return _vm.createLogger($event)
                    },
                    sendLogger: _vm.sendLogger
                  }
                })
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.navTab === _vm.DETAIL_INFORMATION_TAB,
                expression: "navTab === DETAIL_INFORMATION_TAB"
              }
            ],
            staticClass: "setting_tab_content"
          },
          [
            _c(
              "div",
              { staticClass: "setting_tab_content_panel is_active" },
              [
                _c("DetailInformationTab", {
                  attrs: {
                    categories: _vm.dispatchJobDetailForm.categorySetting,
                    jobCategories: _vm.jobCategories,
                    groupName: _vm.groupName,
                    property: _vm.property,
                    resourceFields: _vm.resourceFields,
                    useType: _vm.itemIsUsedInDetailForm,
                    userId: _vm.log.info.userId,
                    companyCategories: _vm.companyCategories,
                    companyResourceFields: _vm.companyResourceFields,
                    propertySearchCompany: _vm.propertySearchCompany
                  },
                  on: {
                    updatedProperty: _vm.updatedProperty,
                    updateResourceField: _vm.updateResourceField,
                    updateCategory: _vm.updatedJobDetailCategory,
                    getJobResourceFields: function($event) {
                      return _vm.getDispatchJobResourceFields(
                        _vm.property,
                        $event
                      )
                    },
                    refreshResourceList: function($event) {
                      return _vm.refreshResourceList($event)
                    },
                    createLogger: function($event) {
                      return _vm.createLogger($event)
                    },
                    sendLogger: _vm.sendLogger,
                    refreshCompanyResourceList: function($event) {
                      return _vm.refreshCompanyResourceList($event)
                    },
                    updatedSearchCompanyProperty:
                      _vm.updatedSearchCompanyProperty,
                    getCompanyResourceFields: function($event) {
                      return _vm.getCompanyResourceFields(
                        _vm.propertySearchCompany,
                        $event
                      )
                    },
                    updateScrollMenu: _vm.scrollMenuItem,
                    updateEditingStatus: _vm.updateEditingStatus
                  }
                })
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.navTab === _vm.LIST_INFORMATION_TAB,
                expression: "navTab === LIST_INFORMATION_TAB"
              }
            ],
            staticClass: "setting_tab_content"
          },
          [
            _c(
              "div",
              { staticClass: "setting_tab_content_panel is_active" },
              [
                _c("ListInformationTab", {
                  attrs: {
                    categories: _vm.dispatchJobListForm.categorySetting,
                    groupName: _vm.groupName,
                    jobCategories: _vm.jobCategories,
                    property: _vm.property,
                    resourceFields: _vm.resourceFields,
                    useType: _vm.itemIsUsedInListForm,
                    userId: _vm.log.info.userId,
                    companyCategories: _vm.companyCategories,
                    companyResourceFields: _vm.companyResourceFields,
                    propertySearchJob: _vm.propertySearchJob
                  },
                  on: {
                    updatedProperty: _vm.updatedProperty,
                    updateResourceField: _vm.updateResourceField,
                    updateCategory: _vm.updatedJobListCategory,
                    getJobResourceFields: function($event) {
                      return _vm.getDispatchJobResourceFields(
                        _vm.propertySearchJob,
                        $event
                      )
                    },
                    refreshResourceList: function($event) {
                      return _vm.refreshResourceList($event)
                    },
                    createLogger: function($event) {
                      return _vm.createLogger($event)
                    },
                    sendLogger: _vm.sendLogger,
                    refreshCompanyResourceList: function($event) {
                      return _vm.refreshCompanyResourceList($event)
                    },
                    updateCompanyResourceField: _vm.updateCompanyResourceField,
                    getCompanyResourceFields: function($event) {
                      return _vm.getCompanyResourceFields(_vm.property, $event)
                    },
                    updatedSearchJobProperty: _vm.updatedSearchJobProperty,
                    updateScrollMenu: _vm.scrollMenuItem,
                    updateEditingStatus: _vm.updateEditingStatus
                  }
                })
              ],
              1
            )
          ]
        )
      ]),
      _c(
        "div",
        { staticClass: "setting_footer", attrs: { id: "setting_footer" } },
        [
          _c(
            "button",
            {
              staticClass: "setting_btn_outline",
              on: {
                click: function($event) {
                  return _vm.cancelChangeJobDataSetting()
                }
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.dispatchJobSettingProperty.CANCEL_BUTTON) +
                  "\n    "
              )
            ]
          ),
          _c(
            "button",
            {
              staticClass: "setting_btn_primary",
              class: {
                setting_btn_disabled: _vm.isDisableSaveBtn || _vm.editingStatus
              },
              on: {
                click: function($event) {
                  return _vm.saveData()
                }
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.dispatchJobSettingProperty.SAVE_BUTTON) +
                  "\n    "
              )
            ]
          ),
          _vm.unSavedData
            ? _c("div", { staticClass: "setting_footer_balloon" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.dispatchJobSettingNotifyProperty.SAVE_CHANGE_DATA
                    ) +
                    "\n    "
                )
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }